export default {
      id: "question-usage",
      viewBox: "0 0 30 26",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#question",
      toString: function () {
        return this.url;
      }
    }